import type { AppLocale } from "../types";
import { englishJson } from "./en";
import { simplifiedChineseJson } from "./zh-Hans";

export type TranslationKey = keyof typeof englishJson;

type Catalog = Record<TranslationKey, string>;

export const messages: Record<AppLocale, Catalog> = {
  en: englishJson,
  "zh-Hans": simplifiedChineseJson,
};

type AssertNever<T extends never> = T;

// These fail compilation when either JSON file gains a key without the other.
type _EnglishMissingKeys = AssertNever<Exclude<keyof typeof simplifiedChineseJson, keyof typeof englishJson>>;
type _EnglishExtraKeys = AssertNever<Exclude<keyof typeof englishJson, keyof typeof simplifiedChineseJson>>;
